import React, { FC, memo } from 'react';
import classes from '../onboardingCarousel.module.css';
import sixCutGif from 'features/selectable_course/static/sixCut.gif';

const SixthCut: FC = memo(() => {
  return (
    <>
      <div className={classes.blackBorder} style={{ fontSize: '1rem', marginBottom: '6vw' }}>
        好きな練習を選んでやり方を確認！
      </div>
      <div className={classes.iidukaFirstWrapper} style={{ width: '82vw' }}>
        <img src={sixCutGif} alt="" width="60%"></img>
      </div>
    </>
  );
});

export default SixthCut;
